import React from 'react';
import {Space, Typography} from 'antd';
import TalentInterviewSteps from "./TalentInterviewSteps";
import {ClockCircleOutlined, QuestionCircleOutlined} from "@ant-design/icons";

const { Text, Paragraph, Title } = Typography;

const InterviewInfo = (props) => {

    const steps = TB.orderBy(laravel.talent_video_interview_steps || [], 'display_index', 'asc')
    return (
        <TalentInterviewSteps {...props}>
            <Space className="mb-4 flex flex-row flex-wrap justify-between" align="center">
                <Title level={3} className="m-0 whitespace-nowrap">Interview Questions</Title>
                <div className="flex items-center">
                    <ClockCircleOutlined className="text-gray-400 mr-2"/>
                    <Text className="text-gray-400 whitespace-nowrap">{TB.ceil(TB.sumBy(steps,'target_length_seconds') / 60)} mins</Text>
                    <QuestionCircleOutlined className="text-gray-400 mr-2 ml-3"/>
                    <Text className="text-gray-400 whitespace-nowrap">{steps.length} questions</Text>
                </div>
            </Space>
            <Paragraph className="text-gray-600 mb-4">
                You're now in the official interview. Answer each question to the best of your
                ability. Once you start recording, you'll have a set time to answer. Good luck!
            </Paragraph>
        </TalentInterviewSteps>
    )
};
export default InterviewInfo;